import React, { Component } from 'react';
import { Header, List, Table } from 'semantic-ui-react';

export default class IndividualIdeationPage extends Component {
  render() {
    return (
      <div>
        <Header as="h1" content="Individual Ideation" />
        <p>
          <b>Due Date:</b>
          1/18/22
        </p>

        <p>
          This is an individual assignment in which you will generate and describe three unique research
          ideas in an area of interest to you in usable privacy and security. The primary goal of this
          assignment is to give you practice in generating good research ideas in usable privacy and
          security. A secondary goal is to afford you an opportunity to explore ideas that excite you
          individually so that you can better contribute to group ideation assignment.
        </p>

        <Header as="h2" content="Motivation" />
        <p>
          Choosing an ambitious and yet feasible project is the black art of research. What makes something
          "research"? The high-order bit is that you are introducing an idea into the world. If you are
          thinking of a systems-oriented contribution, then your idea needs to be the first one to propose
          an approach to the design of interactive systems for usable privacy and security. If you are thinking
          of a social science-oriented contribution, then your idea should be teaching us something general
          about people or their interactions with security and privacy.
        </p>

        <p>
          So, how can you generate a good idea? A simple way you is to find inspiration from the right
          sources. In practice, this means you should read a lot of papers in your area of interest,
          attend inspirational talks and presentations and keep up-to-date with key figures in your
          area of interest are talking about on public fora (e.g., Twitter). By immersing yourself in
          the state-of-the-art of your field, you will naturally start thinking about important and
          relevant problems.
        </p>

        <Header as="h2" content="Details" />
        <p>
          A good scaffold for generating good research ideas when you’re first starting out in a new
          area is to build on prior research. So, for this assignment, pick <i>any</i> of the readings
          listed in the <a href="/schedule">Schedule</a> as your "base".
        </p>

        <p>
          Then, come up with three possible projects and write a 150-word <a
          href="https://users.ece.cmu.edu/~koopman/essays/abstract.html">abstract</a> explaining
          each idea from the perspective of having already done the research. Make sure to name
          which paper the idea is a follow-up on. Search for the original paper in <a
          href="https://scholar.google.com" target="_blank">Google Scholar</a> and use the "Cited By"
          link to make sure that later work citing it hasn't already done your idea — research
          needs to be novel!
        </p>

        <p>
          Here are three examples of excellent individual project ideations from the first time I taught this class:
          <List bulleted>
            <List.Item><a href="/files/ind-ideation-1.pdf" target="_blank">Individual ideation #1</a></List.Item>
            <List.Item><a href="/files/ind-ideation-2.pdf" target="_blank">Individual ideation #2</a></List.Item>
            <List.Item><a href="/files/ind-ideation-3.pdf" target="_blank">Individual ideation #3</a></List.Item>
          </List>
        </p>

        <Header as="h2" content="Deliverable" />
        <p>
          Three 150-word project <a href="https://users.ece.cmu.edu/~koopman/essays/abstract.html">abstracts</a>
          describing a unique follow-up research idea you have based on the three papers listed above.
        </p>

        <Header as="h2" content="Grading" />
        <p>
          You can earn up to 10 points for the assignment along the following two dimensions: research contribution and feasibility.
        </p>

        <Table definition>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell>Insufficient (1 pt)</Table.HeaderCell>
              <Table.HeaderCell>Adequate (3 pts)</Table.HeaderCell>
              <Table.HeaderCell>Proficient (5 pts)</Table.HeaderCell>
              <Table.HeaderCell>Mastery (7 pts)</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row>
              <Table.Cell>Research contribution (7 pts)</Table.Cell>
              <Table.Cell>
                Ideas are present, but they do not clearly articulate why they represent significant
                new knowledge to usable privacy and security or why they have wide applicability.
              </Table.Cell>
              <Table.Cell>
                The ideas demonstrate incremental new knowledge in usable privacy and security and have
                only minor generalizability.
              </Table.Cell>
              <Table.Cell>
                The ideas introduce moderate new knowledge to usable privacy and security and are
                typically generalizable.
              </Table.Cell>
              <Table.Cell>
                The ideas introduce creative new knowledge to usable privacy and security and are
                strongly generalizable.
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>Feasibility (3 pts)</Table.Cell>
              <Table.Cell>
                The ideas have not been scoped to be completable within a semester.
              </Table.Cell>
              <Table.Cell>
                The ideas have been appropriately scoped to be completable within a semester.
              </Table.Cell>
              <Table.Cell />
              <Table.Cell />
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/group-project-assignments/individual-ideation-page.js